// extracted by mini-css-extract-plugin
export default {"brandPromo":"iH-z","carousel":"jH-z"};